import { graphql } from "@/gen";

export const articlePushNotificationTargets = graphql(`
    query ArticlePushNotificationTargets($id: UUID!) {
        article(id: $id) {
            id
            totalPushNotificationTargets
        }
    }
`);

export const articleDetailQuery = graphql(`
    query ArticleDetail($id: UUID!) {
        article(id: $id) {
            id
            title
            source
            imageId
            videoId
            status
            content {
                __typename
                ... on RichTextArticle {
                    content
                }
                ... on ExternalUrlArticle {
                    url
                }

                ... on StoryArticle {
                    items {
                        id
                        rank
                        content {
                            __typename
                            ... on StoryArticleVideo {
                                id
                            }
                            ... on StoryArticleImage {
                                id
                                duration
                            }
                        }
                    }
                }
            }
            playerTags {
                playerId
                kind
            }
            tournamentTags {
                tournamentId
            }
            pushNotificationSent
        }
    }
`);

export const setStatusArticleMutation = graphql(`
    mutation SetStatusArticle($id: UUID!, $status: ArticleStatus!) {
        setArticleStatus(id: $id, status: $status) {
            id
        }
    }
`);

export const sendArticlePushNotificationMutation = graphql(`
    mutation SendArticlePushNotification($id: UUID!, $input: ArticlePushNotificationInput!) {
        sendArticlePushNotification(id: $id, input: $input) {
            id
            subjectKey
        }
    }
`);

export const searchVideosQuery = graphql(`
    query SearchVideos($input: SearchVideosInput!) {
        searchVideos(input: $input) {
            id
            items {
                id
                title
            }
            total
        }
    }
`);

export const videoQuery = graphql(`
    query Video($id: UUID!) {
        video(id: $id) {
            id
            title
        }
    }
`);
